if (!customElements.get("video-reels")) {
  customElements.define(
    "video-reels",
    class VideoReels extends HTMLElement {
      constructor() {
        super();
        this.activeClass = "active";
        this.swiper = this.querySelector(".wt-slider__container");
        this.modalSwiper = null;
      }

      connectedCallback() {
        this.init();
      }

      updateAllVideosSound(swiper) {
        swiper.slides.forEach((slide) => {
          let video = slide.querySelector("video");
          const button = slide.querySelector(".wt-video__sound-toggle");
          if (video) {
            const isSoundOn = button ? button.dataset.sound === "on" : false;
            video.muted = !isSoundOn;
          }
        });
      }

      playAllVideos(swiper) {
        // Disabled background autoplay to optimize performance as requested.
        // Videos will only load and play when the user clicks on them to open the modal.
        return;
      }


      pauseAllVideos(swiper) {
        if (!swiper || !swiper.slides) return;
        swiper.slides.forEach((slide) => {
          let video = slide.querySelector("video");
          if (video) {
            video.pause();
          }
        });
      }

      observeSection(swiper) {
        const observerOptions = {
          root: null,
          rootMargin: "0px",
          threshold: 0.1,
        };

        const sectionObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              this.isIntersecting = entry.isIntersecting;
              if (entry.isIntersecting) {
                // Agar lightbox modal open hai toh background videos play mat karo
                if (!document.querySelector(".video-reels-modal--open")) {
                  this.playAllVideos(swiper);
                }
              } else {
                this.pauseAllVideos(swiper);
              }
            });
          },
          observerOptions,
        );

        sectionObserver.observe(this);
      }

      handleSoundToggle(swiper) {
        const stopSlideEvents = ["click", "mousedown", "touchstart", "pointerdown", "pointerup"];
        
        swiper.slides.forEach((slide, index) => {
          const button = slide.querySelector(".wt-video__sound-toggle");
          const video = slide.querySelector("video");
          const playPauseBtn = slide.querySelector(".shoppable-video__control-button");
          const that = this;

          // Prevent Swiper from sliding when clicking sound buttons
          if (button) {
            stopSlideEvents.forEach(evt => {
              button.addEventListener(evt, (e) => e.stopPropagation());
            });

            button.addEventListener("click", function (e) {
              e.stopPropagation();
              if (!video) return;
              
              const isMuted = video.muted;
              if (isMuted) {
                // Mute all other background videos to prevent overlapping audio
                swiper.slides.forEach((otherSlide) => {
                  if (otherSlide !== slide) {
                    const otherVideo = otherSlide.querySelector("video");
                    if (otherVideo) {
                      otherVideo.muted = true;
                    }
                    const otherBtn = otherSlide.querySelector(".wt-video__sound-toggle");
                    if (otherBtn) {
                      otherBtn.dataset.sound = "off";
                    }
                  }
                });
                
                video.muted = false;
                button.dataset.sound = "on";
              } else {
                video.muted = true;
                button.dataset.sound = "off";
              }
            });
          }

          // Prevent Swiper from sliding when clicking play/pause buttons
          if (playPauseBtn) {
            stopSlideEvents.forEach(evt => {
              playPauseBtn.addEventListener(evt, (e) => e.stopPropagation());
            });
          }
        });
      }

      pasueAllVideos() {
        const videos = this.querySelectorAll("video");
        videos.forEach((video) => {
          video.pause();
        });
      }

      playVideoInActiveSlide(swiper) {
        const sound = swiper.el.dataset.sound;
        const activeSlideVideo =
          this.findActiveSlide(swiper)?.querySelector("video");
        if (activeSlideVideo) {
          activeSlideVideo.play();
          activeSlideVideo.muted = sound !== "on";
        }
      }

      findActiveSlide(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        return activeSlide;
      }

      toggleActiveClass(swiper) {
        const activeSlide = this.findActiveSlide(swiper);
        swiper.slides.forEach((slide) => {
          slide.classList.remove(this.activeClass);

          if (activeSlide === slide) {
            slide.classList.add(this.activeClass);
          }
        });
      }

      handleSlideChange(swiper) {
        this.toggleActiveClass(swiper);
        // Agar modal open hai toh background slides play nahi honi chahiye
        if (!document.querySelector(".video-reels-modal--open")) {
          this.playAllVideos(swiper);
        }
      }

      addVideoEventHandlers(swiper) {
        const that = this;
        swiper.on("slideChange", (swp) => that.handleSlideChange(swp));
      }

      initModal(swiper) {
        // Modal DOM dynamic creation agar already exist na kare
        let modalEl = document.querySelector(".video-reels-modal");
        if (!modalEl) {
          modalEl = document.createElement("div");
          modalEl.className = "video-reels-modal";
          modalEl.setAttribute("aria-hidden", "true");
          modalEl.innerHTML = `
            <div class="video-reels-modal__backdrop"></div>
            <button class="video-reels-modal__close-outer" aria-label="Close modal" style="font-size: 22px; font-weight: 300 !important; line-height: 1 !important; display: flex !important; align-items: center !important; justify-content: center !important; color: #ffffff !important; font-family: sans-serif !important; padding: 0 !important; margin: 0 !important;">
              X
            </button>
            <div class="video-reels-modal__slider-container swiper">
              <div class="swiper-wrapper"></div>
              
              <!-- Navigation Buttons -->
              <div class="swiper-button-prev video-reels-modal__nav-btn">
                <svg viewBox="0 0 24 24"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
              </div>
              <div class="swiper-button-next video-reels-modal__nav-btn">
                <svg viewBox="0 0 24 24"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
              </div>
            </div>
          `;
          document.body.appendChild(modalEl);
        } else {
          // If modal DOM node already exists (e.g. from hot-reload), explicitly force the new SVG close icon to overwrite any stale template
          const staleCloseBtn = modalEl.querySelector(".video-reels-modal__close-outer");
          if (staleCloseBtn) {
            staleCloseBtn.innerHTML = `X`;
            staleCloseBtn.setAttribute("style", "font-size: 22px; font-weight: 300 !important; line-height: 1 !important; display: flex !important; align-items: center !important; justify-content: center !important; color: #ffffff !important; font-family: sans-serif !important; padding: 0 !important; margin: 0 !important;");
          }
        }

        this.modalEl = modalEl;
        this.modalBackdrop = modalEl.querySelector(".video-reels-modal__backdrop");
        this.modalCloseOuter = modalEl.querySelector(".video-reels-modal__close-outer");
        this.modalWrapper = modalEl.querySelector(".swiper-wrapper");
        this.modalSliderContainer = modalEl.querySelector(".video-reels-modal__slider-container");

        // Close handlers register
        const closeFn = () => this.closeModal(swiper);
        this.modalCloseOuter.addEventListener("click", closeFn);
        this.modalBackdrop.addEventListener("click", closeFn);
        
        window.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && this.modalEl.classList.contains("video-reels-modal--open")) {
            closeFn();
          }
        });

        // Loop through slides to listen on clicking video containers to open lightbox
        swiper.slides.forEach((slide) => {
          const videoContainer = slide.querySelector(".video-container");
          if (videoContainer) {
            videoContainer.style.cursor = "pointer";
            videoContainer.addEventListener("click", (e) => {
              // Sound toggle standard button click should be ignored
              if (e.target.closest(".wt-video__sound-toggle")) return;
              e.stopPropagation(); // Stop Swiper from sliding to clicked slide
              this.openModal(slide, swiper);
            });
          }
        });
      }

      updateAllSlidesVolumeIcons(muted) {
        this.modalEl.querySelectorAll(".video-reels-modal__slide").forEach(slide => {
          const video = slide.querySelector("video");
          if (video) video.muted = muted;
          
          const iconVolume = slide.querySelector(".icon-volume");
          const iconMuted = slide.querySelector(".icon-volume-muted");
          if (iconVolume && iconMuted) {
            if (muted) {
              iconVolume.style.display = "none";
              iconMuted.style.display = "block";
            } else {
              iconVolume.style.display = "block";
              iconMuted.style.display = "none";
            }
          }
        });
      }

      async openModal(slide, swiper) {
        // Collect all unique non-duplicate slides to dynamically build lightbox Swiper slides
        const uniqueSlides = [];
        const blockIds = new Set();
        this.querySelectorAll("[data-swiper-slide]").forEach(s => {
          const blockId = s.dataset.blockId;
          if (blockId && !blockIds.has(blockId)) {
            blockIds.add(blockId);
            uniqueSlides.push(s);
          }
        });

        // Find clicked block id index
        const clickedBlockId = slide.dataset.blockId;
        const clickedIndex = uniqueSlides.findIndex(s => s.dataset.blockId === clickedBlockId);

        let slidesHtml = "";
        uniqueSlides.forEach((s, idx) => {
          const bgVideo = s.querySelector("video");
          if (!bgVideo) return;
          const videoSrc = bgVideo.src || bgVideo.querySelector("source")?.src || "";
          const posterAttr = bgVideo.getAttribute("poster") ? `poster="${bgVideo.getAttribute("poster")}"` : "";

          // Product card structure
          const productCard = s.querySelector(".shoppable-product-card");
          let productCardHtml = "";
          if (productCard) {
            productCardHtml = productCard.outerHTML; // outerHTML copies the exact same .shoppable-product-card
          }

          slidesHtml += `
            <div class="swiper-slide video-reels-modal__slide" data-index="${idx}" data-block-id="${s.dataset.blockId}">
              <div class="video-reels-modal__video-wrapper">
                <!-- Progress Bar -->
                <div class="video-reels-modal__progress-bar">
                  <div class="video-reels-modal__progress-fill"></div>
                </div>
                
                <div class="video-reels-modal__top-controls">
                  <div class="video-reels-modal__top-left">
                    <button class="video-reels-modal__control-btn video-reels-modal__close-slide" aria-label="Close" style="font-size: 14px; font-weight: 300 !important; line-height: 1 !important; display: flex !important; align-items: center !important; justify-content: center !important; color: #ffffff !important; font-family: sans-serif !important; padding: 0 !important; margin: 0 !important;">
                      X
                    </button>
                    <button class="video-reels-modal__control-btn video-reels-modal__share" aria-label="Share">
                      <svg viewBox="0 0 24 24"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92z"/></svg>
                    </button>
                  </div>
                  <div class="video-reels-modal__top-right">
                    <button class="video-reels-modal__control-btn video-reels-modal__mute" aria-label="Toggle sound">
                      <svg class="icon icon-volume" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>
                      <svg class="icon icon-volume-muted" viewBox="0 0 24 24" style="fill: currentColor; display: none;"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.21.05-.42.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73 4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>
                    </button>
                    <button class="video-reels-modal__control-btn video-reels-modal__play-pause" aria-label="Play/Pause">
                      <svg class="icon icon-play" viewBox="0 0 24 24" style="fill: currentColor; display: none;"><path d="M8 5v14l11-7z"/></svg>
                      <svg class="icon icon-pause" viewBox="0 0 24 24" style="fill: currentColor;"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>
                    </button>
                  </div>
                </div>
                
                <video class="video-reels-modal__video" playsinline loop preload="auto" ${posterAttr}>
                  <source src="${videoSrc}" type="video/mp4">
                </video>
                
                <div class="video-reels-modal__product-card-container">
                  ${productCardHtml}
                </div>

                <!-- Custom Share Sheet sliding from bottom -->
                <div class="video-reels-modal__share-sheet">
                  <div class="video-reels-modal__share-header">
                    <span class="video-reels-modal__share-title">Share</span>
                    <button class="video-reels-modal__share-close" aria-label="Close share sheet" style="font-size: 18px; font-weight: 300 !important; line-height: 1 !important; display: flex !important; align-items: center !important; justify-content: center !important; color: #666666 !important; font-family: sans-serif !important; padding: 0 !important; margin: 0 !important;">
                      X
                    </button>
                  </div>
                  
                  <div class="video-reels-modal__share-options">
                    <a href="#" class="video-reels-modal__share-option video-reels-modal__share-whatsapp" target="_blank" rel="noopener">
                      <span class="video-reels-modal__share-icon-wrap whatsapp">
                        <svg viewBox="0 0 24 24" style="width: 20px; height: 20px; fill: currentColor; display: block;"><path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.746.953 3.71 1.452 5.705 1.453h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                      </span>
                      <span class="video-reels-modal__share-label">Whatsapp</span>
                    </a>
                    
                    <a href="#" class="video-reels-modal__share-option video-reels-modal__share-twitter" target="_blank" rel="noopener">
                      <span class="video-reels-modal__share-icon-wrap twitter">
                        <svg viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
                      </span>
                      <span class="video-reels-modal__share-label">Twitter</span>
                    </a>
                    
                    <a href="#" class="video-reels-modal__share-option video-reels-modal__share-email" target="_blank" rel="noopener">
                      <span class="video-reels-modal__share-icon-wrap email">
                        <svg viewBox="0 0 24 24"><path d="M0 3v18h24V3H0zm21.518 2L12 12.713 2.482 5h19.036zM2 19V7.183l10 8.104 10-8.104V19H2z"/></svg>
                      </span>
                      <span class="video-reels-modal__share-label">Email</span>
                    </a>
                    
                    <a href="#" class="video-reels-modal__share-option video-reels-modal__share-facebook" target="_blank" rel="noopener">
                      <span class="video-reels-modal__share-icon-wrap facebook">
                        <svg viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                      </span>
                      <span class="video-reels-modal__share-label">Facebook</span>
                    </a>
                    
                    <a href="#" class="video-reels-modal__share-option video-reels-modal__share-pinterest" target="_blank" rel="noopener">
                      <span class="video-reels-modal__share-icon-wrap pinterest">
                        <svg viewBox="0 0 24 24"><path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.906 2.17-2.906 1.024 0 1.517.769 1.517 1.689 0 1.029-.656 2.57-.991 3.997-.28 1.202.607 2.18 1.797 2.18 2.158 0 3.81-2.282 3.81-5.57 0-2.914-2.094-4.95-5.08-4.95-3.46 0-5.49 2.597-5.49 5.28 0 1.047.402 2.169.902 2.775a.379.379 0 0 1 .088.363l-.342 1.395c-.056.226-.184.272-.405.17-1.452-.676-2.358-2.796-2.358-4.502 0-3.668 2.663-7.037 7.683-7.037 4.034 0 7.169 2.874 7.169 6.72 0 4.009-2.528 7.234-6.037 7.234-1.18 0-2.29-.613-2.671-1.343l-.727 2.772c-.262 1.006-.974 2.268-1.452 3.049 1.12.346 2.3.533 3.527.533 6.621 0 11.988-5.367 11.988-11.991C24.005 5.367 18.639 0 12.017 0z"/></svg>
                      </span>
                      <span class="video-reels-modal__share-label">Pinterest</span>
                    </a>
                  </div>
                  
                  <div class="video-reels-modal__share-divider"></div>
                  
                  <button class="video-reels-modal__share-copy">
                    <svg class="icon icon-link" viewBox="0 0 24 24" style="fill: currentColor; width: 16px; height: 16px;"><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/></svg>
                    <span class="video-reels-modal__share-copy-text">Copy Link</span>
                  </button>
                </div>
              </div>
            </div>
          `;
        });

        // Set wrapper content
        this.modalWrapper.innerHTML = slidesHtml;

        // Destroy previous modal swiper instance if exists
        if (this.modalSwiper) {
          this.modalSwiper.destroy(true, true);
          this.modalSwiper = null;
        }

        // Initialize Lightbox Modal Swiper with "peeking" next/prev slides
        let SwiperConstructor;
        try {
          const swiperModule = await import("./swiper-bundle.esm.browser.min.js");
          SwiperConstructor = swiperModule.default;
        } catch (err) {
          console.error("Dynamic Swiper module import failed, attempting window fallback:", err);
          SwiperConstructor = window.Swiper;
        }

        if (!SwiperConstructor) {
          console.error("Swiper constructor is not defined!");
          return;
        }

        this.modalSwiper = new SwiperConstructor(this.modalSliderContainer, {
          slidesPerView: "auto",
          centeredSlides: true,
          spaceBetween: 40,
          loop: true,
          edgeSwipeDetection: true,
          edgeSwipeThreshold: 40,
          navigation: {
            nextEl: ".video-reels-modal__slider-container .swiper-button-next",
            prevEl: ".video-reels-modal__slider-container .swiper-button-prev",
          },
          breakpoints: {
            320: {
              spaceBetween: 16
            },
            768: {
              spaceBetween: 40
            }
          },
          on: {
            slideChange: () => this.handleModalSlideChange(swiper),
          }
        });

        // Attach listeners on dynamic slide elements (including clones dynamically built by Swiper loop)
        this.modalSwiper.slides.forEach(sSlide => {
          const video = sSlide.querySelector("video");
          const progressFill = sSlide.querySelector(".video-reels-modal__progress-fill");
          const muteBtn = sSlide.querySelector(".video-reels-modal__mute");
          const playPauseBtn = sSlide.querySelector(".video-reels-modal__play-pause");
          const closeSlideBtn = sSlide.querySelector(".video-reels-modal__close-slide");
          const shareBtn = sSlide.querySelector(".video-reels-modal__share");
          const videoWrapper = sSlide.querySelector(".video-reels-modal__video-wrapper");

          // Sync progress line fill
          if (video && progressFill) {
            video.addEventListener("timeupdate", () => {
              const percent = (video.currentTime / video.duration) * 100 || 0;
              progressFill.style.width = `${percent}%`;
            });
          }

          // Play/Pause Action
          const togglePlay = (e) => {
            if (e) e.stopPropagation();
            if (!video) return;
            const playIcon = playPauseBtn?.querySelector(".icon-play");
            const pauseIcon = playPauseBtn?.querySelector(".icon-pause");
            if (video.paused) {
              video.play().catch(err => console.log(err));
              if (playIcon) playIcon.style.display = "none";
              if (pauseIcon) pauseIcon.style.display = "block";
            } else {
              video.pause();
              if (playIcon) playIcon.style.display = "block";
              if (pauseIcon) pauseIcon.style.display = "none";
            }
          };
          playPauseBtn?.addEventListener("click", togglePlay);
          videoWrapper?.addEventListener("click", (e) => {
            if (e.target.closest(".video-reels-modal__top-controls") || e.target.closest(".video-reels-modal__product-card-container")) return;
            togglePlay(e);
          });

          // Volume control inside slide
          muteBtn?.addEventListener("click", (e) => {
            e.stopPropagation();
            if (!video) return;
            video.muted = !video.muted;
            swiper.el.dataset.sound = video.muted ? "off" : "on";
            this.updateAllSlidesVolumeIcons(video.muted);
            this.updateAllVideosSound(swiper);
          });

          // Close button trigger
          closeSlideBtn?.addEventListener("click", (e) => {
            e.stopPropagation();
            this.closeModal(swiper);
          });

          const shareSheet = sSlide.querySelector(".video-reels-modal__share-sheet");
          
          // Stop propagation inside share sheet to prevent sliding/play-pause toggles
          if (shareSheet) {
            const stopShareEvents = ["click", "mousedown", "touchstart", "pointerdown", "pointerup"];
            stopShareEvents.forEach(evt => {
              shareSheet.addEventListener(evt, (e) => e.stopPropagation());
            });
            
            // Wire up close button
            const shareCloseBtn = shareSheet.querySelector(".video-reels-modal__share-close");
            shareCloseBtn?.addEventListener("click", (e) => {
              e.stopPropagation();
              shareSheet.classList.remove("video-reels-modal__share-sheet--open");
            });

            // Wire up copy button
            const copyBtn = shareSheet.querySelector(".video-reels-modal__share-copy");
            copyBtn?.addEventListener("click", (e) => {
              e.stopPropagation();
              navigator.clipboard.writeText(window.location.href).then(() => {
                const btnText = copyBtn.querySelector(".video-reels-modal__share-copy-text");
                if (btnText) {
                  const originalText = btnText.textContent;
                  btnText.textContent = "Copied!";
                  copyBtn.classList.add("copied");
                  setTimeout(() => {
                    btnText.textContent = originalText;
                    copyBtn.classList.remove("copied");
                  }, 2000);
                }
              }).catch(err => console.error("Clipboard copy failed:", err));
            });
          }

          // Share panel action
          shareBtn?.addEventListener("click", (e) => {
            e.stopPropagation();
            if (shareSheet) {
              // Extract product title or page title
              const productTitleEl = sSlide.querySelector(".wt-dot__title");
              const title = productTitleEl ? productTitleEl.textContent.trim() : document.title;
              const url = window.location.href;

              // Dynamically update hrefs
              const wa = shareSheet.querySelector(".video-reels-modal__share-whatsapp");
              if (wa) wa.href = `https://api.whatsapp.com/send?text=${encodeURIComponent(title + " - " + url)}`;

              const tw = shareSheet.querySelector(".video-reels-modal__share-twitter");
              if (tw) tw.href = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;

              const em = shareSheet.querySelector(".video-reels-modal__share-email");
              if (em) em.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`;

              const fb = shareSheet.querySelector(".video-reels-modal__share-facebook");
              if (fb) fb.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

              const pin = shareSheet.querySelector(".video-reels-modal__share-pinterest");
              if (pin) pin.href = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&description=${encodeURIComponent(title)}`;

              // Open share sheet
              shareSheet.classList.add("video-reels-modal__share-sheet--open");
            }
          });
        });

        // Sync and pause background autoplay
        if (swiper.autoplay && typeof swiper.autoplay.stop === "function") {
          swiper.autoplay.stop();
        }
        this.pauseAllVideos(swiper);

        // Open modal
        this.modalEl.classList.add("video-reels-modal--open");
        this.modalEl.setAttribute("aria-hidden", "false");
        document.body.classList.add("video-reels-modal-active");

        // Sync clicked background currentTime to active slide video
        const activeSlideBg = uniqueSlides[clickedIndex];
        const activeSlideBgVideo = activeSlideBg?.querySelector("video");
        
        // Go to slide beautifully and instantly
        this.modalSwiper.slideToLoop(clickedIndex, 0);

        if (activeSlideBgVideo) {
          const activeModalSlide = this.modalSwiper.slides[this.modalSwiper.activeIndex];
          const activeModalVideo = activeModalSlide?.querySelector("video");
          if (activeModalVideo) {
            activeModalVideo.currentTime = activeSlideBgVideo.currentTime || 0;
          }
        }

        // Trigger active slide playback & bindings
        this.handleModalSlideChange(swiper);
      }

      handleModalSlideChange(swiper) {
        if (!this.modalSwiper) return;

        const activeSlide = this.modalSwiper.slides[this.modalSwiper.activeIndex];
        if (!activeSlide) return;

        const soundOn = swiper.el.dataset.sound === "on";
        const muted = !soundOn;

        // Loop over lightbox slides to play the active and pause all inactive ones
        this.modalSwiper.slides.forEach(slide => {
          // Close share sheet automatically on all slides when sliding to prevent hanging overlay
          const slideShareSheet = slide.querySelector(".video-reels-modal__share-sheet");
          if (slideShareSheet) {
            slideShareSheet.classList.remove("video-reels-modal__share-sheet--open");
          }

          const video = slide.querySelector("video");
          if (video) {
            if (slide === activeSlide) {
              video.muted = muted;

              // Sync overlay play/pause and volume icons
              const playIcon = slide.querySelector(".icon-play");
              const pauseIcon = slide.querySelector(".icon-pause");
              if (playIcon && pauseIcon) {
                playIcon.style.display = "none";
                pauseIcon.style.display = "block";
              }

              const iconVolume = slide.querySelector(".icon-volume");
              const iconMuted = slide.querySelector(".icon-volume-muted");
              if (iconVolume && iconMuted) {
                if (muted) {
                  iconVolume.style.display = "none";
                  iconMuted.style.display = "block";
                } else {
                  iconVolume.style.display = "block";
                  iconMuted.style.display = "none";
                }
              }

              // Play video
              video.play().catch(err => console.log("Modal active autoplay gesture block:", err));

              // Re-bind cloned dynamic custom product form
              const productFormEl = slide.querySelector("product-form");
              if (productFormEl && !productFormEl.form) {
                productFormEl.form = productFormEl.querySelector("form");
                productFormEl.formInput = productFormEl.form?.querySelector("[name=id]");
                if (productFormEl.formInput) productFormEl.formInput.disabled = false;
                productFormEl.form?.addEventListener("submit", productFormEl.onSubmitHandler.bind(productFormEl));
                productFormEl.cart = document.querySelector("cart-drawer");
                productFormEl.cartType = productFormEl.cart?.dataset.cartType;
                productFormEl.submitButton = productFormEl.querySelector('[type="submit"]');
                productFormEl.body = document.querySelector("body");
                if (document.querySelector("cart-drawer")) {
                  productFormEl.submitButton?.setAttribute("aria-haspopup", "dialog");
                }
                productFormEl.hideErrors = productFormEl.dataset.hideErrors === "true";
              }
            } else {
              video.pause();
              const progressFill = slide.querySelector(".video-reels-modal__progress-fill");
              if (progressFill) progressFill.style.width = "0%";
            }
          }
        });

      }

      closeModal(swiper) {
        if (!this.modalEl.classList.contains("video-reels-modal--open")) return;

        // Lightbox volume state synchronization
        const activeModalSlide = this.modalSwiper?.slides[this.modalSwiper.activeIndex];
        const activeModalVideo = activeModalSlide?.querySelector("video");
        if (activeModalVideo) {
          swiper.el.dataset.sound = activeModalVideo.muted ? "off" : "on";
        }
        this.updateAllVideosSound(swiper);

        // Pause and reset all videos inside the Swiper slider
        if (this.modalSwiper && this.modalSwiper.slides) {
          this.modalSwiper.slides.forEach(slide => {
            const video = slide.querySelector("video");
            if (video) {
              video.pause();
              video.src = "";
            }
          });
        }

        // Reset elements
        this.modalWrapper.innerHTML = "";

        if (this.modalSwiper) {
          this.modalSwiper.destroy(true, true);
          this.modalSwiper = null;
        }

        // Close modal
        this.modalEl.classList.remove("video-reels-modal--open");
        this.modalEl.setAttribute("aria-hidden", "true");
        document.body.classList.remove("video-reels-modal-active");

        // Resume background autoplay loop
        if (swiper.autoplay && typeof swiper.autoplay.start === "function") {
          swiper.autoplay.start();
        }
        this.playAllVideos(swiper);
      }

      checkSwiperInitialization() {
        const swiperContainer = this.swiper;
        const mySwiperInstance = swiperContainer.swiper;

        if (swiperContainer.classList.contains("swiper-initialized")) {
          this.addVideoEventHandlers(mySwiperInstance);
          this.handleSlideChange(mySwiperInstance);
          this.handleSoundToggle(mySwiperInstance);
          this.observeSection(mySwiperInstance);
          
          // Lightbox Modal initialize karein
          this.initModal(mySwiperInstance);

          clearInterval(this.checkInterval);
        }
      }

      init() {
        this.checkInterval = setInterval(
          this.checkSwiperInitialization.bind(this),
          500,
        );
      }
    },
  );
}
